import { useState, useEffect } from 'react';

const useDateRangeHandler = (initialFormData) => {
  const [formData, setFormData] = useState(initialFormData);
  const [dateError, setDateError] = useState('');

  // Calculate number of nights between two dates
  const calculateNights = (checkIn, checkOut) => {
    if (!checkIn || !checkOut) return 0;
    const start = new Date(checkIn);
    const end = new Date(checkOut);
    const diffTime = Math.abs(end - start);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    const today = new Date().toISOString().split('T')[0];
    
    try {
      if (name === 'check_in_date') {
        // Validate check-in date is not in the past
        if (value < today) {
          setDateError('Check-in date cannot be in the past');
          return;
        }

        // Update check-in date and validate check-out date
        const updatedData = {
          ...formData,
          check_in_date: value,
          check_out_date: formData.check_out_date && 
            new Date(value) > new Date(formData.check_out_date) 
            ? value 
            : formData.check_out_date
        };

        // Calculate nights if both dates are set
        if (updatedData.check_out_date) {
          updatedData.number_of_nights = calculateNights(
            updatedData.check_in_date, 
            updatedData.check_out_date
          );
        }

        setFormData(updatedData);
        setDateError('');

      } else if (name === 'check_out_date') {
        // Validate check-out date is not before check-in date
        if (formData.check_in_date && value < formData.check_in_date) {
          setDateError('Check-out date cannot be before check-in date');
          return;
        }

        // Update check-out date and calculate nights
        const updatedData = {
          ...formData,
          check_out_date: value,
          number_of_nights: formData.check_in_date ? 
            calculateNights(formData.check_in_date, value) : 0
        };

        setFormData(updatedData);
        setDateError('');
      }
    } catch (error) {
      console.error('Error handling date change:', error);
      setDateError('Invalid date selection');
    }
  };

  // Reset date-related fields
  const resetDates = () => {
    setFormData(prev => ({
      ...prev,
      check_in_date: '',
      check_out_date: '',
      number_of_nights: ''
    }));
    setDateError('');
  };

  return {
    formData,
    dateError,
    handleDateChange,
    resetDates
  };
};

export default useDateRangeHandler;